import { render, staticRenderFns } from "./payCont.vue?vue&type=template&id=b3876494&scoped=true"
import script from "./payCont.vue?vue&type=script&lang=js"
export * from "./payCont.vue?vue&type=script&lang=js"
import style0 from "./payCont.vue?vue&type=style&index=0&id=b3876494&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3876494",
  null
  
)

export default component.exports